import { Button, createListCollection, Field, HStack, Input, Popover, Portal, Select, Text } from "@chakra-ui/react";
import { LuPause, LuPlay, LuSettings } from "react-icons/lu";
import { useAppStore } from "../../../context/store";

function SettingCameraImage() {
  const cameraImageAllAutoPalyTimeout = useAppStore((s) => s.cameraImageAllAutoPalyTimeout);
  const cameraImageAllAutoPalySkip = useAppStore((s) => s.cameraImageAllAutoPalySkip);
  const cameraImageAllAutoPaly = useAppStore((s) => s.cameraImageAllAutoPaly);
  const setCameraImageAllAutoPalyTimeout = useAppStore.getState().setCameraImageAllAutoPalyTimeout;
  const setCameraImageAllAutoPalySkip = useAppStore.getState().setCameraImageAllAutoPalySkip;
  const setCameraImageAllAutoPaly = useAppStore.getState().setCameraImageAllAutoPaly;

  const skipOptions = createListCollection({
    items: [
      { label: "Skip: Normal", value: 1 },
      { label: "Skip: 1 Frame", value: 2 },
      { label: "Skip: 2 Frames", value: 3 },
      { label: "Skip: 3 Frames", value: 4 },
      { label: "Skip: 4 Frames", value: 5 },
      { label: "Skip: 5 Frames", value: 6 },
    ],
  });

  return (
    <Popover.Root positioning={{ placement: "bottom-end" }} size={"lg"}>
      <Popover.Trigger asChild>
        <Button userSelect={"none"} rounded="lg" boxShadow="lg" bg={"Background"}>
          <HStack gap={2} mx={2}>
            <LuSettings color="MenuText" />
            <Text textStyle={"sm"} color="MenuText">
              Camera Image
            </Text>
          </HStack>
        </Button>
      </Popover.Trigger>
      <Portal width={"450px"}>
        <Popover.Positioner>
          <Popover.Content width={"fit-content"}>
            <Popover.Arrow />
            <Popover.Body p={2}>
              <HStack gap={2}>
                <Button
                  userSelect={"none"}
                  rounded="lg"
                  boxShadow="lg"
                  bg={cameraImageAllAutoPaly ? "green" : "Background"}
                  onClick={() => {
                    setCameraImageAllAutoPaly(!cameraImageAllAutoPaly);
                  }}
                >
                  {cameraImageAllAutoPaly ? <LuPause color={cameraImageAllAutoPaly ? "white" : "MenuText"} /> : <LuPlay color="MenuText" />}
                </Button>
                <Select.Root
                  collection={skipOptions}
                  defaultValue={[cameraImageAllAutoPalySkip]}
                  size="sm"
                  onSelect={(v, c) => {
                    setCameraImageAllAutoPalySkip(parseInt(v.value));
                  }}
                >
                  <Select.HiddenSelect />

                  <Select.Control>
                    <Select.Trigger>
                      <Select.ValueText placeholder="Skip" />
                    </Select.Trigger>
                    <Select.IndicatorGroup>
                      <Select.Indicator />
                    </Select.IndicatorGroup>
                  </Select.Control>
                  <Select.Positioner>
                    <Select.Content>
                      {skipOptions.items.map((option) => (
                        <Select.Item item={option} key={option.value}>
                          {option.label}
                          <Select.ItemIndicator />
                        </Select.Item>
                      ))}
                    </Select.Content>
                  </Select.Positioner>
                </Select.Root>
              </HStack>
              <Field.Root required mt={3}>
                <Field.Label>Timeout(ms)</Field.Label>
                <Input
                  placeholder="Timeout"
                  type="number"
                  defaultValue={cameraImageAllAutoPalyTimeout}
                  onChange={(v) => {
                    setCameraImageAllAutoPalyTimeout(parseInt(v.target.value));
                  }}
                />
              </Field.Root>
            </Popover.Body>
          </Popover.Content>
        </Popover.Positioner>
      </Portal>
    </Popover.Root>
  );
}

export default SettingCameraImage;
